<template>
  <v-container class="pa-0" fluid ref="vendor-booth-container">
    <v-app-bar
      color="primary"
      dense
      dark
      :max-width="maxWidth"
      class="mx-auto rounded-b-lg"
      fixed
    >
      <v-app-bar-nav-icon :to="'/vendor-hall/1'">
        <v-icon>mdi-arrow-left</v-icon>
      </v-app-bar-nav-icon>
      <v-card
        class="d-flex justify-space-between align-center"
        color="primary"
        flat
        tile
        width="80%"
      >
        <v-toolbar-title>{{ vendor_details.company_name }}'s Booth</v-toolbar-title>
        <div>
          <v-btn
            color="success darken-2"
            class="mx-2"
            small
            @click="showPublicChat"
          >
            <v-icon class="mr-1">mdi-chat</v-icon>
            Public Chat
          </v-btn>
          <v-menu
            offset-y
            v-if="respresentative.length >= 1"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success darken-2"
                dark
                v-bind="attrs"
                v-on="on"
                class="mx-2"
                small
              >
                <v-icon class="mr-1">mdi-comment-account</v-icon>
                Live Chat with a Rep
              </v-btn>
            </template>
            <v-list>
              <v-subheader
                >Representatives ({{ respresentative.length }})
              </v-subheader>
              <v-list-item
                v-for="(item, index) in respresentative"
                :key="index"
              >
                <v-badge
                  bordered
                  bottom
                  :color="item.attendee.status_color"
                  class="px-2"
                  dot
                  offset-x="20"
                  offset-y="10"
                >
                  <v-avatar size="40">
                    <v-img :src="item.attendee.profile_pic"></v-img>
                  </v-avatar>
                </v-badge>
                <v-list-item-content>
                  <v-list-item-title>
                    <span>{{ item.attendee.first_name+' '+item.attendee.last_name }}</span>
                    <span class="text-caption" v-if="item.attendee.designation"
                      >( {{ item.attendee.designation }} )</span
                    >
                  </v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.attendee.company_name
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="d-flex flex-row">
                  <v-btn
                    icon
                    target="_blank"
                    :href="item.attendee.linkedin_url"
                    v-if="item.attendee.linkedin_url"
                  >
                    <v-icon color="light-blue darken-4">mdi-linkedin</v-icon>
                  </v-btn>
                  <v-btn icon @click="startChatWithAttendee(item.attendee)">
                    <v-icon color="grey darken-3"
                      >mdi-message-text-outline</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu
            offset-y
            v-if="respresentative.length >= 1"
            :close-on-content-click="false"
            v-model="schedule_chat_menu"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success darken-2"
                dark
                v-bind="attrs"
                v-on="on"
                class="mx-2"
                small
              >
                <v-icon class="mr-1">mdi-calendar-clock</v-icon>
                Schedule a Chat
              </v-btn>
            </template>
            <v-card>
              <v-card-text class="pa-1">
                <v-textarea
                  placeholder="Message"
                  outlined
                  v-model="pre_defined_message"
                  rows="5"
                  hint="Hit enter to send!"
                  @keyup.enter.exact="sendScheduleMessage()"
                  persistent-hint
                  :loading="send_loading"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-menu right bottom min-width="365" offset-y max-width="365" v-if="vendor_details.rep_data && vendor_details.rep_data.attendee_id==myself.attendee_id">
            <template v-slot:activator="{ on : on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                dark
                @click="getBoothVisitor(attrs)"
              >
                <v-icon>mdi-comment-account-outline</v-icon>
              </v-btn>
            </template>

            <v-list style="max-height:350px;overflow-y:auto">
              <span  v-for="(item, index) in booth_visitors" :key="index">
              <v-list-item>
                <v-list-item-content class="py-1">
                  <v-list-item-title>
                    <span>{{ item.attendee.first_name+' '+item.attendee.last_name }} has visited your booth</span>
                    <v-btn icon @click="startChatWithAttendee(item.attendee)">
                      <v-icon color="grey darken-3">mdi-message-text-outline</v-icon>
                    </v-btn>
                  </v-list-item-title>
                  <v-list-item-subtitle>Last Visted : {{ moment(item.updated_at).format('DD-MM-YYYY hh:mm A') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider v-if="(booth_visitors.length-1)!=index"></v-divider>

              </span>
            </v-list>
          </v-menu>
        </div>
        <div></div>
      </v-card>
    </v-app-bar>
    <basic-booth v-if="vendor_details.sponsor_type == 3" />
    <gold-booth v-if="vendor_details.sponsor_type == 4" />
    <platinum-booth v-if="vendor_details.sponsor_type == 5" />
    <diamond-booth v-if="vendor_details.sponsor_type == 6" />
    <!-- <booth-details-image /> -->
    <PublicChat v-if="show_public_chat_modal" />
    <v-speed-dial bottom fixed class="mb-16 ml-8" left>
      <template v-slot:activator>
        <v-btn color="yellow darken-2" dark :to="'/vendor-hall/1'">
          <v-icon>mdi-arrow-left</v-icon>
          Return to Ballroom
        </v-btn>
      </template>
    </v-speed-dial>
  </v-container>
</template>
<script>
import BasicBooth from "@/components/vendor-hall/BasicBooth";
import GoldBooth from "@/components/vendor-hall/GoldBooth";
import PlatinumBooth from "@/components/vendor-hall/PlatinumBooth";
import DiamondBooth from "@/components/vendor-hall/DiamondBooth";
import PublicChat from "@/components/vendor-hall/PublicChat";
import axios from "@/helper/axios";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    BasicBooth,
    GoldBooth,
    PlatinumBooth,
    DiamondBooth,
    PublicChat,
  },
  data() {
    return {
      public_chat: true,
      subscription: null,
      loading: false,
      preview_data: null,
      show_preview: false,
      show_desc_modal: false,
      respresentative: [],
      send_loading: false,
      pre_defined_message: "Hello, I can't talk now but would like to chat later. Please message me back so we can schedule a time. Thanks!",
      schedule_chat_menu: false,
      booth_visitors : [],
      beforeunloadFired: false
    };
  },
  computed: {
    ...mapState("vendor", ["vendor_details"]),
    ...mapState("public_chat", ["show_public_chat_modal"]),
    ...mapState("utils", ["maxWidth"]),
    myself() {
      return JSON.parse(localStorage.getItem("flaacos_user"));
    },
  },
  methods: {
    ...mapMutations("notifications", [
      "setExpandBox",
      "setTempPrivateMessage",
      "setChatPrivate",
      "setPrivateChatUser",
    ]),
    ...mapMutations("public_chat", ["setPublicChatData"]),
    ...mapActions("vendor", ["fetchVendor"]),
    ...mapMutations("vendor_directory", ["setVendorData"]),
    getVendorDetails() {
      let _self = this;
      axios
        .get("/vendor/details?vendor_id=" + this.$route.params.vendor_id)
        .then(function (response) {
          _self.vendor_details = response.data.data;
        })
        .catch(function (e) {
          console.log(e);
        });
      console.log(_self.vendor_details);
      _self.loading = false;
    },
    addBoothView() {
      let _self = this;
      axios
        .post("/booth/add_view",{vendor_id: this.$route.params.vendor_id})
        .then(function () {

        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    addBoothViewTime() {
      this.beforeunloadFired = true
      let _self = this;
      axios.post("/booth/add_view_time",{vendor_id: this.vendor_id, start_timestamp: this.start_timestamp, end_timestamp: this.moment().format('YYYY-MM-DD HH:mm:ss')})
        .then(function () {

        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    getRespresentative() {
      let _self = this;
      axios
        .get("/representative/list?vendor_id=" + this.$route.params.vendor_id)
        .then(function (response) {
          _self.respresentative = response.data.data;
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    startChatWithAttendee(attendee) {
      this.setChatPrivate(true);
      this.setTempPrivateMessage(attendee);
      this.setPrivateChatUser(attendee);
      this.setExpandBox(0);
    },
    sendScheduleMessage() {
      if (this.pre_defined_message.length) {
        this.send_loading = true;
        let data = {
          message: this.pre_defined_message,
          receive_by: this.respresentative[0].attendee.attendee_id,
        };
        axios
          .post("/attendee/add_message", data)
          .then(() => {
            this.schedule_chat_menu = false;
          })
          .then(() => {
            this.send_loading = false;
          });
      }
    },
    showPublicChat() {
      this.setPublicChatData({
        key: "show_public_chat_modal",
        data: true,
      });
    },
    getBoothVisitor(attrs){
      let _self = this
      if(attrs['aria-expanded']=='false'){
        axios.get("/booth/get_view?vendor_id=" + this.$route.params.vendor_id)
        .then(function (response) {
          _self.booth_visitors = response.data.data;
        })
        .catch(function (e) {
          console.log(e);
        });
      }
    }
  },

  mounted() {
    this.start_timestamp = this.moment().format('YYYY-MM-DD HH:mm:ss');
    this.vendor_id = this.$route.params.vendor_id;
    this.fetchVendor(this.$route.params.vendor_id);
    this.getRespresentative();
    this.addBoothView()
    this.$vuetify.goTo(this.$refs["vendor-booth-container"], {
      offset: -200,
    });
    this.$vuetify.goTo(this.$refs["vendor-booth-container"], {
      offset: -200,
    });
    this.subscription = this.$ws.socket.getSubscription(
      `user:${this.myself.attendee_id}`
    );
    if (!this.subscription) {
      this.subscription = this.$ws.subscribe(`user:${this.myself.attendee_id}`);
      this.subscription.emit("vendorvisit", {
        vendor: this.$route.params.vendor_id,
        visitor: this.myself.attendee_id,
      });
    } else {
      this.subscription.emit("vendorvisit", {
        vendor: this.$route.params.vendor_id,
        visitor: this.myself.attendee_id,
      });
    }
  },
  beforeDestroy(){
    this.setVendorData({
      key: "search_vendor",
      data: '',
    });
    this.addBoothViewTime();
  }
};
</script>
<style>
</style>
